module.exports = __webpack_public_path__ + "img/bcaires.22425aaf.png";